import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const fiatWalletRoutes: RouteRecordRaw[] = [
  {
    path: routes.WALLET_DEPOSIT_SUCCESS,
    name: 'WALLET_DEPOSIT_SUCCESS',
    component: () => import('./WalletDepositSuccessPage.vue'),
    meta: { requiresAuth: true },
  },
]
